import { Bet } from "interfaces/bet";

export const resolveMinBetAmountContestEntry = (bets: Bet[], contestEntryId: string, balance: number, numberOfSelections: number) => {
  const contestBets = bets.filter(b => b.contest_entry_id === contestEntryId);
  // Create a Set of unique contestants by splitting names by `;`
  const uniqueContestantBets = new Set();
  contestBets.forEach(bet => {
    if (bet.contestant_name) {
      bet.contestant_name.split(';').forEach(name => uniqueContestantBets.add(name.trim()));
    }
  });
  const contestantVal = uniqueContestantBets.size + numberOfSelections
  if (contestantVal <= 1) {
    return balance <= 100 ? 0: 100
  }
  if (contestantVal === 2) {
    return balance <= 100 ? 0: 100
  }
  if (contestantVal === 3) {
    return balance <= 100 ? 0: 100
  }
  if (contestantVal === 4) {
    return balance <= 100 ? 0: 100
  }
  return 0;
};

export const resolveMinBetAmountForContestEntry = (bets: Bet[], contestEntryId: string, numberOfSelections: number) => {
  // All picks must be at least $100
  return 100;
};

export const resolveMaxBetAmountForContestEntry = (bets: Bet[], contestEntryId: string, numberOfSelections: number) => {
  // All picks must be at most $350
  return 350;
};